import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { handleUnauthorized } from "../../utils/apiHelper";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "./../child/Alert/DengerAlert";
import Loader from "../child/Loder";
import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import { Icon } from "@iconify/react/dist/iconify.js";
import Multiselect from "multiselect-react-dropdown";

const UploadPost = () => {
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState("");
  const [releasedate, setReleaseDate] = useState("");
  const [ready, setReady] = useState(false);
  const [type, setType] = useState("movie");
  const [dropdowns, setDropdowns] = useState({
    categories: [],
    // subtitles: [], // Commented out as not used
    // audios: [],    // Commented out as not used
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const authToken = localStorage.getItem("authToken");
  const navigate = useNavigate();
  const inputRefs = useRef({
    banner: null,
    video: null,
    title: null,
    releaseDate: null,
    categoryId: null,
    // subTitleLanguage: null, // Commented out as not used
    // audioLanguage: null,    // Commented out as not used
    // quality: null,          // Commented out as not used
    description: null,
    cast: [], // Array of refs for each cast block
  });
  const [formData, setFormData] = useState({
    title: "",
    releaseDate: "",
    banner: null,
    video: null,
    categoryId: [],
    // subTitleLanguage: [], // Commented out as not used
    // audioLanguage: [],    // Commented out as not used
    // quality: "480p",      // Commented out as not used
    description: "",
    type: "movie",
    cast: [{ name: "", image: "" }],
  });
  const [previews, setPreviews] = useState({
    banner: null,
    video: null,
    cast: null,
  });

  const [s3Urls, setS3Urls] = useState({
    banner: "",
    video: "",
    cast: "",
  });
  const { id } = useParams();
  const isEditMode = !!id;

  const baseURL = process.env.REACT_APP_BASE_URL;

  // Function to clear messages
  const clearMessage = () => {
    setTimeout(() => {
      setSuccessMessage("");
      setErrorMessage("");
    }, 3000);
  };

  // Reusable fetch function
  const getDropdownData = async (endpoint) => {
    const res = await fetch(`${baseURL}/user/dropList/${endpoint}`);
    if (!res.ok) throw new Error(`Failed to fetch ${endpoint}`);
    const data = await res.json();
    return data?.data || [];
  };

  // Fetch dropdowns on load
  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const [categories] = await Promise.all([
          getDropdownData("Category"),
          // getDropdownData("Subtitlelanguages"), // Commented out as not used
          // getDropdownData("Audiolanguage"),     // Commented out as not used
        ]);
        setDropdowns({ categories });
      } catch (error) {
        console.error("Dropdown fetch error:", error);
      }
    };

    fetchDropdowns();
  }, []);

  useEffect(() => {
    if (!isEditMode) return;
    const fetchSetting = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/admin/postDataById/${id}`,
          {
            method: "GET",
            headers: { Authorization: `Bearer ${authToken}` },
          }
        );

        if (response.status === 401) {
          handleUnauthorized(navigate);
          return;
        }

        const data = await response.json();
        if (response.ok) {
          const result = data.result;

          setFormData((prev) => ({
            ...prev,
            ...result,
            releaseDate: result.releaseDate?.slice(0, 10) || "", // YYYY-MM-DD
            categoryId: result.categoryId.map((item) => item.title),
            // audioLanguage: result.audioLanguage.map((item) => item.title), // Commented out as not used
            // subTitleLanguage: result.subTitleLanguage.map((item) => item.title), // Commented out as not used
          }));

          setPreviews((prev) => ({
            ...prev,
            banner: result.banner || "",
            video: result.video || "",
            cast: Array.isArray(result.cast)
              ? result.cast.map((c) => c.image || "")
              : [],
          }));
        } else {
          setErrorMessage("Error fetching Data");
          clearMessage();
        }
      } catch (error) {
        setErrorMessage("Error fetching Data");
        clearMessage();
      } finally {
        setLoading(false);
      }
    };
    fetchSetting();
  }, [id, navigate]);

  const s3Client = new S3Client({
    region: process.env.REACT_APP_AWS_REGION,
    credentials: {
      accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
      secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
    },
  });

  const uploadToS3 = async (file) => {
    const extension = file.name.split(".").pop(); // get file extension
    const fileKey = `temp/${Date.now()}.${extension}`;

    const params = {
      Bucket: process.env.REACT_APP_AWS_S3_BUCKET_NAME,
      Key: fileKey,
      Body: await file.arrayBuffer(),
      ContentType: file.type,
      ACL: "public-read",
    };

    const command = new PutObjectCommand(params);
    await s3Client.send(command);

    return `https://${process.env.REACT_APP_AWS_S3_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${fileKey}`;
  };

  const handleInputChange = async (e) => {
    const { name, value, files } = e.target;

    if (name === "banner" || name === "video") {
      const file = files[0];
      if (!file) return;

      // Validate MIME type
      if (
        name === "banner" &&
        !["image/jpeg", "image/jpg", "image/png"].includes(file.type)
      ) {
        setErrors((prev) => ({
          ...prev,
          banner: "Only JPG, JPEG, or PNG files are allowed for the banner.",
        }));
        return;
      }

      if (name === "video" && !file.type.startsWith("video/")) {
        setErrors((prev) => ({
          ...prev,
          video: "Only video file are allowed for video.",
        }));
        return;
      }

      // ✅ Clear previous error if valid
      setErrors((prev) => ({ ...prev, [name]: null }));

      // Preview
      const previewUrl = URL.createObjectURL(file);
      setPreviews((prev) => ({ ...prev, [name]: previewUrl }));
      setFormData((prev) => ({ ...prev, [name]: file }));
    } else {
      const trimmedValue = value.replace(/\s{2,}/g, " ").trimStart();
      setFormData((prev) => ({ ...prev, [name]: trimmedValue }));
      if (errors[name]) {
        setErrors((prev) => ({
          ...prev,
          [name]: trimmedValue.trim() !== "" ? "" : prev[name],
        }));
      }
    }
  };

  const addCast = () => {
    setFormData((prev) => ({
      ...prev,
      cast: [...prev.cast, { name: "", image: "" }],
    }));
  };

  const removeCast = (index) => {
    const updatedCast = [...formData.cast];
    updatedCast.splice(index, 1);
    setFormData((prev) => ({ ...prev, cast: updatedCast }));
  };

  const handleCastChange = (index, field, value) => {
    const updatedCast = [...formData.cast];
    updatedCast[index][field] = value;
    setFormData((prev) => ({ ...prev, cast: updatedCast }));
    if (field === "name" && errors[`cast_name_${index}`]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[`cast_name_${index}`];
        return newErrors;
      });
    }
  };

  const handleCastImageUpload = (file, index) => {
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (!file || !allowedTypes.includes(file.type)) {
      setErrors((prev) => ({
        ...prev,
        [`cast_image_${index}`]: "Only JPG, JPEG, or PNG files are allowed.",
      }));
      return;
    }

    const imageUrl = URL.createObjectURL(file);
    const updatedCast = [...formData.cast];
    updatedCast[index].preview = imageUrl;
    updatedCast[index].image = file; // Store File object instead of uploading now

    setFormData((prev) => ({
      ...prev,
      cast: updatedCast,
    }));

    // Clear error if exists
    if (errors[`cast_image_${index}`]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[`cast_image_${index}`];
        return newErrors;
      });
    }
  };

  const validateInputs = () => {
    const newErrors = {};
    let firstErrorKey = null;
    if (!formData.title.trim()) {
      newErrors.title = "Title is required";
      firstErrorKey = firstErrorKey || "title";
    }
    if (!formData.releaseDate) {
      newErrors.releaseDate = "Release date is required";
      firstErrorKey = firstErrorKey || "releaseDate";
    }
    if (!formData.banner) {
      newErrors.banner = "Movie poster is required";
      firstErrorKey = firstErrorKey || "banner";
    }
    if (!formData.video) {
      newErrors.video = "Video file is required";
      firstErrorKey = firstErrorKey || "video";
    }
    if (formData.categoryId.length === 0) {
      newErrors.categoryId = "Category is required";
      firstErrorKey = firstErrorKey || "categoryId";
    }
    // if (!formData.subTitleLanguage) { // Commented out as not used
    //   newErrors.subTitleLanguage = "Subtitles language is required";
    //   firstErrorKey = firstErrorKey || "subTitleLanguage";
    // }
    // if (formData.audioLanguage.length === 0) { // Commented out as not used
    //   newErrors.audioLanguage = "Audio track language is required";
    //   firstErrorKey = firstErrorKey || "audioLanguage";
    // }
    // if (!formData.quality) { // Commented out as not used
    //   newErrors.quality = "Quality is required";
    //   firstErrorKey = firstErrorKey || "quality";
    // }
    if (!formData.description) {
      newErrors.description = "Description is required";
      firstErrorKey = firstErrorKey || "description";
    }
    formData.cast.forEach((member, index) => {
      if (!member.name?.trim()) {
        const key = `cast_name_${index}`;
        newErrors[key] = `Cast ${index + 1} name is required`;
        firstErrorKey = firstErrorKey || key;
      }
      if (!member.image) {
        const key = `cast_image_${index}`;
        newErrors[key] = `Cast ${index + 1} image is required`;
        firstErrorKey = firstErrorKey || key;
      }
    });

    setErrors(newErrors);
    return { isValid: Object.keys(newErrors).length === 0, firstErrorKey };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { isValid, firstErrorKey } = validateInputs();

    if (!isValid) {
      if (
        firstErrorKey.startsWith("cast_name_") ||
        firstErrorKey.startsWith("cast_image_")
      ) {
        const index = parseInt(firstErrorKey.split("_")[2], 10);
        const castRef = inputRefs.current.cast?.[index];
        if (castRef) {
          castRef.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      } else if (inputRefs.current[firstErrorKey]) {
        inputRefs.current[firstErrorKey].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        inputRefs.current[firstErrorKey].focus?.(); // optional
      }
      return;
    }
    // if (!validateInputs()) return;

    setLoading(true);
    setErrorMessage(""); // clear previous errors

    try {
      // Convert date to DD/MM/YYYY
      const formatDateToDDMMYYYY = (dateStr) => {
        const [year, month, day] = dateStr.split("-");
        return `${day}/${month}/${year}`;
      };
      const payload = {
        title: formData.title,
        releaseDate: formatDateToDDMMYYYY(formData.releaseDate),
        categoryId: formData.categoryId,
        // subTitleLanguage: formData.subTitleLanguage, // Commented out as not used
        // audioLanguage: formData.audioLanguage,       // Commented out as not used
        // quality: formData.quality,                   // Commented out as not used
        description: formData.description,
        type: formData.type,
      };

      // ✅ Upload banner image
      if (formData.banner instanceof File) {
        const bannerUrl = await uploadToS3(formData.banner, "banner");
        payload.banner = bannerUrl;
      } else if (isEditMode && s3Urls.banner) {
        payload.banner = s3Urls.banner;
      } else if (formData.banner) {
        payload.banner = formData.banner;
      }
      if (formData.video instanceof File) {
        const videoUrl = await uploadToS3(formData.video, "video");
        payload.video = videoUrl;
        payload.videotype = "video";
      } else if (isEditMode && s3Urls.video) {
        payload.video = s3Urls.video;
      } else if (formData.video) {
        payload.video = formData.video;
        payload.videotype = "youtube";
      }

      // ✅ Upload cast images
      const uploadedCast = [];
      for (const castMember of formData.cast) {
        if (castMember.image instanceof File) {
          try {
            const uploadedImageUrl = await uploadToS3(castMember.image, "cast");
            uploadedCast.push({
              name: castMember.name,
              image: uploadedImageUrl,
            });
          } catch (err) {
            console.error("Cast image upload failed:", err);
            setErrorMessage("Failed to upload cast image. Please try again.");
            setLoading(false);
            return;
          }
        } else if (isEditMode && castMember.image) {
          uploadedCast.push({
            name: castMember.name,
            image: castMember.image,
          });
        } else if (typeof castMember.image === "string") {
          // If image is already a URL (e.g., from TMDb)
          uploadedCast.push({
            name: castMember.name,
            image: castMember.image,
          });
        }
      }

      // ✅ Include cast only if there's any
      if (uploadedCast.length > 0) {
        payload.cast = uploadedCast;
      }

      // ✅ Final API call
      const API_ENDPOINT = `${baseURL}/admin/${
        isEditMode ? `uploadPostedit/${id}` : "uploadPost"
      }`;

      const response = await fetch(API_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccessMessage(data.message);
        setTimeout(() => navigate("/uploadpost"), 3000);
      } else {
        setErrorMessage(data.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Upload error:", error);
      setErrorMessage("An unexpected error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (dropdowns.categories.length > 0 && formData.categoryId.length > 0) {
      setReady(true);
    }
  }, [dropdowns.categories, formData.categoryId]);

  useEffect(() => {
    if (successMessage || errorMessage) {
      const timer = setTimeout(() => {
        if (successMessage) setSuccessMessage("");
        if (errorMessage) setErrorMessage("");
      }, 3000); // 3 seconds

      return () => clearTimeout(timer); // Cleanup on unmount or re-render
    }
  }, [successMessage, errorMessage]);

  //Fetch movie suggestions
  const bearerToken = process.env.REACT_APP_TMDB_BEARER;

  // Search suggestions
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchQuery.length > 1) {
        fetchSuggestions(searchQuery, type);
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchQuery, type]);

  const fetchSuggestions = async (query, searchType = "movie") => {
    const response = await fetch(
      `https://api.themoviedb.org/3/search/${searchType}?query=${encodeURIComponent(
        query
      )}&page=1`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${bearerToken}`,
          Accept: "application/json",
        },
      }
    );

    const data = await response.json();
    setSuggestions(data.results || []);
  };

  const getDetails = async (id, mediaType = "movie") => {
    const response = await fetch(
      `https://api.themoviedb.org/3/${mediaType}/${id}`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
          accept: "application/json",
        },
      }
    );
    return await response.json();
  };

  const getCast = async (id, mediaType = "movie") => {
    const response = await fetch(
      `https://api.themoviedb.org/3/${mediaType}/${id}/credits`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
          accept: "application/json",
        },
      }
    );
    const data = await response.json();
    return data.cast?.slice(0, 1) || [];
  };

  const getTrailer = async (id, mediaType = "movie") => {
    const res = await fetch(
      `https://api.themoviedb.org/3/${mediaType}/${id}/videos`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
          "Content-Type": "application/json;charset=utf-8",
        },
      }
    );
    const data = await res.json();
    if (!data.results || data.results.length === 0) return null;

    let trailer = data.results.find(
      (vid) => vid.type === "Trailer" && vid.site === "YouTube"
    );
    if (!trailer) {
      trailer = data.results.find(
        (vid) => vid.type === "Teaser" && vid.site === "YouTube"
      );
    }
    if (!trailer) {
      trailer = data.results.find((vid) => vid.site === "YouTube");
    }

    return trailer ? `https://www.youtube.com/watch?v=${trailer.key}` : null;
  };

  // When clicking a suggestion
  const handleSuggestionClick = async (item) => {
    setSearchQuery("");
    setSuggestions([]);

    const [details, castList, trailerUrl] = await Promise.all([
      getDetails(item.id, type),
      getCast(item.id, type),
      getTrailer(item.id, type),
    ]);

    const bannerUrl = item.poster_path
      ? `https://image.tmdb.org/t/p/w500${item.poster_path}`
      : "";

    const castData = castList.map((member) => ({
      name: member.name,
      image: member.profile_path
        ? `https://image.tmdb.org/t/p/w185${member.profile_path}`
        : null,
    }));

    setFormData((prev) => ({
      ...prev,
      title: type === "movie" ? item.title : item.name,
      releaseDate:
        type === "movie" ? item.release_date : item.first_air_date || "",
      description: item.overview || "",
      banner: bannerUrl,
      categoryId: Array.isArray(details.genres)
        ? details.genres
            .map((g) => g.name)
            .filter((g) => dropdowns.categories.some((cat) => cat.title === g))
        : [],
      // audioLanguage: Array.isArray(details.spoken_languages) // Commented out as not used
      //   ? details.spoken_languages
      //       .map((g) => g.english_name)
      //       .filter((g) => dropdowns.audios.some((lang) => lang.title === g))
      //   : [],
      // subTitleLanguage: Array.isArray(details.spoken_languages) // Commented out as not used
      //   ? details.spoken_languages
      //       .map((g) => g.english_name)
      //       .filter((g) => dropdowns.subtitles.some((lang) => lang.title === g))
      //   : [],
      cast: castData,
      video: trailerUrl || "",
    }));

    setPreviews((prev) => ({
      ...prev,
      banner: bannerUrl,
      cast: castData.map((c) => c.image || ""),
    }));
  };

  return (
    <div className="row gy-4">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            {successMessage && <SuccessAlert message={successMessage} />}
            {errorMessage && (
              <DengerAlert
                message={errorMessage}
                onClose={() => setErrorMessage("")}
              />
            )}
            <form
              className="row gy-3 needs-validation"
              noValidate
              onSubmit={handleSubmit}
            >
              <div className="">
                <label className="form-label">Select Type</label>
                <span className="text-danger-600">*</span>
                <select
                  name="type"
                  value={formData.type}
                  onChange={(e) => {
                    setType(e.target.value);
                    setFormData((prev) => ({ ...prev, type: e.target.value }));
                  }}
                  className="form-select"
                >
                  <option value="movie">Movie</option>
                  <option value="tv">TV Show</option>
                </select>
              </div>

              <div className="position-relative">
                <label className="form-label">
                  Search {formData.type === "tv" ? "TV Show" : "Movie"}
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={`Search for a ${
                    formData.type === "tv" ? "TV show" : "movie"
                  }...`}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                {suggestions.length > 0 && (
                  <ul
                    className="list-group position-absolute w-100"
                    style={{
                      zIndex: 10,
                      maxHeight: "200px",
                      overflowY: "auto",
                    }}
                  >
                    {suggestions.map((item) => (
                      <li
                        key={item.id}
                        className="list-group-item list-group-item-action"
                        onClick={() => handleSuggestionClick(item)}
                      >
                        {item.title || item.name}{" "}
                        {/* ✅ Handles both movies & TV */}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              {/* Banner Image */}
              <div className="" ref={(el) => (inputRefs.current.banner = el)}>
                <label className="form-label">Movie Poster</label>
                <span className="text-danger-600">*</span>
                <input
                  type="file"
                  name="banner"
                  accept="image/*"
                  className="form-control"
                  onChange={handleInputChange}
                />
                {errors.banner && (
                  <p className="text-danger">{errors.banner}</p>
                )}
                {previews.banner && (
                  <img
                    src={previews.banner}
                    alt="Banner Preview"
                    width="150"
                    height="150"
                    className="mt-2"
                  />
                )}
              </div>

              {/* Title */}
              <div className="">
                <label className="form-label">Title</label>
                <span className="text-danger-600">*</span>
                <input
                  type="text"
                  name="title"
                  ref={(el) => (inputRefs.current.title = el)}
                  className="form-control"
                  value={formData.title}
                  placeholder="Enter Title"
                  onChange={handleInputChange}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/\s{2,}/g, " ")
                      .trimStart();
                  }}
                />
                {errors.title && (
                  <p className="text-danger mb-0">{errors.title}</p>
                )}
              </div>
              {/* Release Date */}
              <div className="">
                <label className="form-label">Release Date</label>
                <span className="text-danger-600">*</span>
                <input
                  type="date"
                  name="releaseDate"
                  ref={(el) => (inputRefs.current.releaseDate = el)}
                  className="form-control"
                  value={formData.releaseDate}
                  onChange={handleInputChange}
                />
                {errors.releaseDate && (
                  <p className="text-danger mb-0">{errors.releaseDate}</p>
                )}
              </div>
              {/* video file */}
              <div className="">
                <label className="form-label">Video File</label>
                <span className="text-danger-600">*</span>
                <input
                  type="file"
                  name="video"
                  ref={(el) => (inputRefs.current.video = el)}
                  accept="video/*"
                  className="form-control"
                  onChange={handleInputChange}
                />

                {/* show validation error if exists */}
                {errors.video && <p className="text-danger">{errors.video}</p>}

                {/* Case 1: Show uploaded video preview (when selecting a file) */}
                {previews.video && previews.videotype === "video" ? (
                  <video
                    key={previews.video}
                    width="400"
                    height="250"
                    controls
                    className="mt-2"
                    muted
                  >
                    <source src={previews.video} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : previews.video && previews.videotype === "youtube" ? (
                  /* Case 2: Show YouTube trailer from previews */
                  <div className="trailer-preview mt-2">
                    <iframe
                      width="560"
                      height="315"
                      src={previews.video.replace("watch?v=", "embed/")}
                      title="Movie Trailer"
                      frameBorder="0"
                      allowFullScreen
                    ></iframe>
                  </div>
                ) : formData.video ? (
                  /* Case 3: Handle formData.video (edit mode or after file select) */
                  typeof formData.video === "string" ? (
                    // ✅ If it's a YouTube link (string)
                    <div className="trailer-preview mt-2">
                      <iframe
                        width="560"
                        height="315"
                        src={formData.video.replace("watch?v=", "embed/")}
                        title="Movie Trailer"
                        frameBorder="0"
                        allowFullScreen
                      ></iframe>
                    </div>
                  ) : formData.video instanceof File ? (
                    // ✅ If it's a file object
                    <video
                      width="400"
                      height="250"
                      controls
                      className="mt-2"
                      muted
                      src={URL.createObjectURL(formData.video)}
                    />
                  ) : null
                ) : null}
              </div>
              {/* Categories */}
              <div className="">
                <label className="form-label">Category</label>
                <span className="text-danger-600">*</span>
                <div ref={(el) => (inputRefs.current.categoryId = el)}>
                  {dropdowns.categories.length > 0 && (
                    <Multiselect
                      options={dropdowns.categories}
                      selectedValues={dropdowns.categories.filter((cat) =>
                        formData.categoryId.includes(cat.title)
                      )}
                      onSelect={(selectedList) => {
                        setFormData((prev) => ({
                          ...prev,
                          categoryId: selectedList.map((item) => item.title),
                        }));
                        if (errors.categoryId) {
                          setErrors((prev) => ({
                            ...prev,
                            categoryId: "",
                          }));
                        }
                      }}
                      onRemove={(selectedList) => {
                        setFormData((prev) => ({
                          ...prev,
                          categoryId: selectedList.map((item) => item.title),
                        }));

                        // ✅ Also clear error on remove (optional logic)
                        if (selectedList.length > 0 && errors.categoryId) {
                          setErrors((prev) => ({
                            ...prev,
                            categoryId: "",
                          }));
                        }
                      }}
                      displayValue="title"
                      placeholder={
                        formData.categoryId.length === 0
                          ? "Select categories"
                          : ""
                      }
                      style={{
                        chips: { background: "#0d6efd", fontSize: "13px" },
                        searchBox: {
                          border: "1px solid #ced4da",
                          borderRadius: "0.375rem",
                          padding: "8px",
                        },
                        optionContainer: {
                          border: "1px solid #ced4da",
                        },
                        option: {
                          color: "#000",
                          backgroundColor: "#fff",
                        },
                      }}
                      className={`${errors.categoryId ? "is-invalid" : ""}`}
                    />
                  )}
                  {errors.categoryId && (
                    <p className="text-danger mb-0">{errors.categoryId}</p>
                  )}
                </div>
              </div>

              {/* Subtitle Languages - Commented out as not used */}
              {/* <div className="">
                <label className="form-label">Subtitles Language</label>
                <span className="text-danger-600">*</span>
                <div ref={(el) => (inputRefs.current.subTitleLanguage = el)}>
                  {dropdowns.subtitles.length > 0 && (
                    <Multiselect
                      options={dropdowns.subtitles}
                      selectedValues={dropdowns.subtitles.filter((cat) =>
                        formData.subTitleLanguage.includes(cat.title)
                      )}
                      onSelect={(selectedList) => {
                        setFormData((prev) => ({
                          ...prev,
                          subTitleLanguage: selectedList.map(
                            (item) => item.title
                          ),
                        }));
                        if (errors.subTitleLanguage) {
                          setErrors((prev) => ({
                            ...prev,
                            subTitleLanguage: "",
                          }));
                        }
                      }}
                      onRemove={(selectedList) => {
                        setFormData((prev) => ({
                          ...prev,
                          subTitleLanguage: selectedList.map(
                            (item) => item.title
                          ),
                        }));
                      }}
                      displayValue="title"
                      placeholder={
                        formData.subTitleLanguage.length === 0
                          ? "Select Subtitle Languages"
                          : ""
                      }
                      style={{
                        chips: { background: "#0d6efd", fontSize: "13px" },
                        searchBox: {
                          border: "1px solid #ced4da",
                          borderRadius: "0.375rem",
                          padding: "8px",
                        },
                        optionContainer: {
                          border: "1px solid #ced4da",
                        },
                        option: {
                          color: "#000",
                          backgroundColor: "#fff",
                        },
                      }}
                      className={`${
                        errors.subTitleLanguage ? "is-invalid" : ""
                      }`}
                    />
                  )}
                  {errors.subTitleLanguage && (
                    <p className="text-danger mb-0">
                      {errors.subTitleLanguage}
                    </p>
                  )}
                </div>
              </div> */}

              {/* Audio Languages - Commented out as not used */}
              {/* <div className="">
                <label className="form-label">Audio Track Language</label>
                <span className="text-danger-600">*</span>
                <div ref={(el) => (inputRefs.current.audioLanguage = el)}>
                  {dropdowns.audios.length > 0 && (
                    <Multiselect
                      options={dropdowns.audios}
                      selectedValues={dropdowns.audios.filter((cat) =>
                        formData.audioLanguage.includes(cat.title)
                      )}
                      onSelect={(selectedList) => {
                        setFormData((prev) => ({
                          ...prev,
                          audioLanguage: selectedList.map((item) => item.title),
                        }));
                        if (errors.audioLanguage) {
                          setErrors((prev) => ({
                            ...prev,
                            audioLanguage: "",
                          }));
                        }
                      }}
                      onRemove={(selectedList) => {
                        setFormData((prev) => ({
                          ...prev,
                          audioLanguage: selectedList.map((item) => item.title),
                        }));
                      }}
                      displayValue="title"
                      placeholder={
                        formData.audioLanguage.length === 0
                          ? "Select Audio Track Languages"
                          : ""
                      }
                      style={{
                        chips: { background: "#0d6efd", fontSize: "13px" },
                        searchBox: {
                          border: "1px solid #ced4da",
                          borderRadius: "0.375rem",
                          padding: "8px",
                        },
                        optionContainer: {
                          border: "1px solid #ced4da",
                        },
                        option: {
                          color: "#000",
                          backgroundColor: "#fff",
                        },
                      }}
                      className={`${errors.audioLanguage ? "is-invalid" : ""}`}
                    />
                  )}
                  {errors.audioLanguage && (
                    <p className="text-danger mb-0">{errors.audioLanguage}</p>
                  )}
                </div>
              </div> */}

              {/* Quality - Commented out as not used */}
              {/* <div className="">
                <label className="form-label">Quality</label>
                <span className="text-danger-600">*</span>
                <select
                  name="quality"
                  ref={(el) => (inputRefs.current.quality = el)}
                  className="form-select"
                  value={formData.quality}
                  onChange={handleInputChange}
                >
                  <option value="1080p">1080p</option>
                  <option value="720p">720p</option>
                  <option value="480p">480p</option>
                  <option value="360p">360p</option>
                  <option value="240p">240p</option>
                </select>
                {errors.quality && (
                  <p className="text-danger mb-0">{errors.quality}</p>
                )}
              </div> */}

              {/* Description */}
              <div className="">
                <label className="form-label">Description</label>
                <span className="text-danger-600">*</span>
                <textarea
                  name="description"
                  ref={(el) => (inputRefs.current.description = el)}
                  className="form-control"
                  rows="3"
                  placeholder="Enter description..."
                  value={formData.description}
                  onChange={handleInputChange}
                ></textarea>
                {errors.description && (
                  <p className="text-danger mb-0">{errors.description}</p>
                )}
              </div>

              <div className="mt-3">
                <label className="form-label">Starring Actor</label>
                <span className="text-danger-600">*</span>

                {formData.cast.map((actor, index) => (
                  <div
                    key={index}
                    className="border rounded p-3 mb-2"
                    ref={(el) => (inputRefs.current.cast[index] = el)} // ✅ assign ref
                  >
                    {/* Cast Name Input */}
                    <div className="mb-3">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Cast Name"
                        value={actor.name}
                        onChange={(e) =>
                          handleCastChange(index, "name", e.target.value)
                        }
                      />
                      {errors[`cast_name_${index}`] && (
                        <p className="text-danger">
                          {errors[`cast_name_${index}`]}
                        </p>
                      )}
                    </div>

                    {/* Cast Image Upload */}
                    <div className="mb-3">
                      <input
                        type="file"
                        accept="image/*"
                        className="form-control"
                        onChange={(e) =>
                          handleCastImageUpload(e.target.files[0], index)
                        }
                      />
                      {errors[`cast_image_${index}`] && (
                        <p className="text-danger">
                          {errors[`cast_image_${index}`]}
                        </p>
                      )}

                      {/* Show preview if available */}
                      {(actor.preview || actor.image) && (
                        <img
                          src={actor.preview || actor.image} // prioritizes new preview
                          alt="Preview"
                          className="mt-2"
                          style={{
                            width: "100px",
                            height: "100px",
                            borderRadius: "6px",
                          }}
                        />
                      )}
                    </div>

                    {/* Remove Button */}
                    {index !== 0 && (
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => removeCast(index)}
                      >
                        Remove
                      </button>
                    )}
                  </div>
                ))}


                {/* Add Cast Button */}
                {/* <button
                  type="button"
                  className="btn btn-primary btn-sm mt-2"
                  onClick={addCast}
                >
                  + Add Cast
                </button> */}
              </div>

              <div className="col-12">
                <button
                  className="btn btn-primary mt-3 float-end"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadPost;